import {Injectable} from '@angular/core';
import {HttpModelConverter} from "../../../../../../core/converter/httpModel.converter";
import {CamJobSummaryConverter} from "./camJobSummary.converter";
import {CamJobModel} from "../camJob.model";
import {
    ProviderCamMachineSummaryConverter
} from "../../../../../provider/cammachine/api/entity/providerCamMachineSummary.converter";
import {
    ProductStockUnitSummaryConverter
} from "../../../../../../product/stock/unit/api/entity/converter/productStockUnitSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class CamJobConverter extends HttpModelConverter<CamJobModel> {

    constructor(private summaryConverter: CamJobSummaryConverter,
                private camMachineSummaryConverter: ProviderCamMachineSummaryConverter,
                private productStockUnitSummaryConverter: ProductStockUnitSummaryConverter) {
        super();
    }

    protected createInstance(): CamJobModel {
        return new CamJobModel();
    }

    protected enrichObject(result: CamJobModel, src: CamJobModel) {
        result.camMachineProvider = this.camMachineSummaryConverter.convert(src.camMachineProvider);
        result.productStockUnits = this.productStockUnitSummaryConverter.convertFromArray(src.productStockUnits);
        result.summary = this.summaryConverter.convert(src.summary);
    }

}
